import home from './home';
import homeCancer from './homeCancer';
import texts from './texts';
import common from './common';
import results from './results';
import resultsCancer from './resultsCancer';
import stories from './stories';
import storiesCancer from './storiesCancer';
import questions from './questions';

export default {
    translation: {
        home,
        homeCancer,
        texts,
        common,
        results,
        resultsCancer,
        stories,
        storiesCancer,
        questions,
    },
};
